import React from 'react'
import { useTranslation } from 'react-i18next'
import iconMove from '~/assets/svgs/icon-move.svg?react'
import { QuickActionButtonVariants } from '~/components/shared/componentStyles/QuickActionButton.style'
import { QuickActionButton } from '~/components/shared/QuickActionButton'

interface MoveVoicemailProps {
  onClick: () => void
}

export const MoveVoicemail = ({ onClick }: MoveVoicemailProps) => {
  const { t } = useTranslation()
  return (
    <QuickActionButton
      onClick={onClick}
      actionIcon={iconMove}
      tooltipText={t('voicemail.tooltip.move')}
      variant={QuickActionButtonVariants.Default_200}
    />
  )
}
